import React, {useState} from "react";
import apiHelper from "../../../util/ApiHelper";
import {Link} from "react-router-dom";
import {useLoading} from "../../../util/LoadingProvider";
import {Box, Grid, Typography} from "@material-ui/core";
import {toast} from "react-toastify";
import {formatDatetime, modal} from "../../../util";
import FilmTagForm from "./filmTagForm";
import DragAndDropTable
    from "../../common/DragAndDropTable";

export default function FilmTagPage(props) {
    const {disabled, match} = props;
    const [globalFilter, setGlobalFilter] = useState("");
    const [isSearched, setIsSearched] = useState(false);
    const [orderingDisabled, setOrderingDisabled] = useState(false);
    const [rows, setRows] = useState([]);
    const [searchString, setSearchString] = useState("");
    const {setLoading} = useLoading();
    const [pageSize, setPageSize] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [seq, setSeq] = useState(0);

    const getFilmTags = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getFilmTags({
                page: pageIndex,
                pageSize,
                offset: (pageIndex + 1) * pageSize,
                keyword: searchString
            });
            console.log(result);
            setRows(result.data.content.filter((x) => x));
            setTotalElements(result.data.totalElements);
            setTotalPages(result.data.totalPages);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [pageIndex, pageSize, searchString, setLoading]);

    const getAllFilmTags = async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getFilmTags({
                pageSize: 99999999,
            });
            const maxSeq = result.data.content.reduce((x, y) => (
                Math.max(x.sequence ? x.sequence : 0, y.sequence ? y.sequence : 0)
            ), 0);
            setSeq(maxSeq + 1);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    React.useEffect(() => {
        getAllFilmTags();
    }, [])

    React.useEffect(() => {
        if (pageSize) getFilmTags();
    }, [getFilmTags]);

    const handleSorting = (bool) => {
        if (!isSearched) {
            setOrderingDisabled(bool);
        }
    };

    const handleSearch = (searchString) => {
        setGlobalFilter(searchString);
        setIsSearched(true);
        setOrderingDisabled(true);
    };

    const getMaxSeqInRows = (rows) => {
        let seq = null;
        rows.forEach((e) => {
          if ((e.seq && seq === null) || (seq !== null && e.seq > seq)) {
            console.log(`seq`, seq, e.seq)
            seq = e.seq
          }
        })
        return seq;
      }

    const saveOrdering = async () => {
        try {
            const seqData = {};
            rows.forEach((e, i) => {
              seqData[e.id] = i + 1;
            });
            const result = await apiHelper.hkiff.orderFilmTags(seqData);
            if (result.data.code === 0) {
              toast.dark("Your changes is saved.");
              await getFilmTags();
            }
          } catch (err) {
            console.log(err);
          }
    };

    const handleDelete = async (row) => {
        const decision = await modal.fire({
            title: "Delete File",
            text: "Are you sure to delete this tag?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            try {
                const {id} = row;
                const result = await apiHelper.hkiff.deleteFilmTagById(id);
                if (result.status === 200) {
                    toast.dark("The tag is deleted.");
                    await getFilmTags();
                }
            } catch (err) {
                console.log(err);
            }
        }
    };

    const columns = React.useMemo(
        () => [
            {
                Header: "Id",
                accessor: "id",
                Cell: ({row}) => {
                    return (
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "#306F9D",
                            }}
                            to={`${match.url}/${row.original.id}`}
                        >
                            {row.original.id}
                        </Link>
                    );
                },
            },
            {
                Header: "Tag Name (English)",
                accessor: "localizations.en.name",
                Cell: ({row}) => {
                    return (
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "#306F9D",
                            }}
                            to={`${match.url}/${row.original.id}`}
                        >
                            {row.original.localizations.en.name}
                        </Link>
                    );
                },
            },
            {
                Header: "Tag Name (Traditional Chinese)",
                accessor: "localizations.tc.name",
                Cell: ({row}) => {
                    return (
                        <Link
                            style={{
                                textDecoration: "none",
                                color: "#306F9D",
                            }}
                            to={`${match.url}/${row.original.id}`}
                        >
                            {row.original.localizations.tc.name}
                        </Link>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "status",
                disableGlobalFilter: true,
                Cell: ({row}) => {
                    switch (row.original.status) {
                        default:
                        case false:
                            return <span
                                style={{
                                    color: "#306F9D",
                                }}>Inactive</span>
                        case true:
                            return <span
                                style={{
                                    color: "#306F9D",
                                }}>Active</span>
                    }
                },
            },
          {
            Header: "Last Update",
            accessor: "updateTime",
            disableGlobalFilter: true,
            Cell: ({row}) => {
              return formatDatetime(row.original.updateTime);
            },
          }
        ],
        []
    );

    return (
        <>
            <Box width="100%">
                <Typography variant="h4" gutterBottom>
                    Film &gt; Film Tag
                </Typography>
            </Box>
            <Grid container spacing={4}>
                <Grid item xs={4}>
                    <FilmTagForm
                        description="Add New Tag"
                        submitBtnTxt="Add New Tag"
                        gridSize={4}
                        upperBtnGroupSize="75%"
                        fetchData={getFilmTags}
                        disabled={disabled}
                        seq={seq}
                        setSeq={setSeq}
                    />
                </Grid>
                <Grid item xs={8}>
                    <DragAndDropTable
                        globalFilter={globalFilter}
                        orderingDisabled={orderingDisabled}
                        handleSorting={handleSorting}
                        handleSearch={handleSearch}
                        searchString={searchString}
                        setSearchString={setSearchString}
                        fetchData={getFilmTags}
                        data={rows}
                        setData={setRows}
                        columns={columns}
                        bulkDeleteApi={(ids) => apiHelper.hkiff.bulkDeleteFilmTags(ids)}
                        subject="tag"
                        saveOrderingApi={saveOrdering}
                        disabled={disabled}
                        withPagination={true}
                        editDeleteAction={true}
                        handleDelete={handleDelete}
                        deleteByRow={true}
                        setParentPageSize={setPageSize}
                        setParentPageIndex={setPageIndex}
                        parentPageIndex={pageIndex}
                        totalElements={totalElements}
                        totalPages={totalPages}
                    />
                </Grid>
            </Grid>
        </>
    );
}
